"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotSubscriber = void 0;
const events_1 = require("events");
class SlotSubscriber {
    constructor(connection, _config) {
        this.connection = connection;
        this.eventEmitter = new events_1.EventEmitter();
    }
    async subscribe() {
        if (this.subscriptionId) {
            return;
        }
        this.currentSlot = await this.connection.getSlot('confirmed');
        this.subscriptionId = this.connection.onSlotChange((slotInfo) => {
            this.currentSlot = slotInfo.slot;
            this.eventEmitter.emit('newSlot', slotInfo.slot);
        });
    }
    getSlot() {
        return this.currentSlot;
    }
    async unsubscribe() {
        if (this.subscriptionId) {
            await this.connection.removeSlotChangeListener(this.subscriptionId);
        }
    }
}
exports.SlotSubscriber = SlotSubscriber;
